import { useState } from 'react'

import { useI18n } from '@runtime/core/i18n/i18n'
import { useAppStore } from '@runtime/core/store/appStore'
import {
  DEFAULT_POSTER_THEME_ID,
  getThemePosterPreview,
  svgPoster,
} from '@runtime/core/theme/posterThemes'

type ActivePosterPreviewProps = {
  className?: string
  width: number
  height: number
  loading?: 'eager' | 'lazy'
  testId: string
}

export default function ActivePosterPreview({
  className,
  width,
  height,
  loading = 'eager',
  testId,
}: ActivePosterPreviewProps) {
  const { t } = useI18n()
  const preview = useAppStore(state =>
    getThemePosterPreview(state.themeId || DEFAULT_POSTER_THEME_ID),
  )
  const [failedPreview, setFailedPreview] = useState<string | null>(null)
  const image = preview && preview !== failedPreview ? preview : svgPoster(t('common.poster'))

  return (
    <img
      className={className}
      src={image}
      alt=""
      width={width}
      height={height}
      loading={loading}
      onError={() => setFailedPreview(preview)}
      data-testid={testId}
    />
  )
}
